<!-- 停售模板 -->
<template>
	<el-dialog  title="选择停售数据"  :visible.sync="dialogVisible" top="2rem"   width="90%" :append-to-body="true" center>
		<subComponents @selectDataAction="selectDataAction" ref="showSelectData"></subComponents>
		<div class='components_content_box'>
			<div class="components_content_top">
				<el-form :inline="true" :model="getRequestData" class="demo-form-inline" v-if="pageShowData[0]" size="mini">
					<el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in pageShowData[0].jurconfigform" :key="formOneKey">
						<el-input v-if="formOneValue.entityField == 'bgmId'" clearable
							@focus="$refs['showSelectData'].openBox('businessGoodsList','bgmId','bgmId')" 
							v-model="getRequestData.bgmName"  maxlength="64">
						</el-input>
						<el-input v-else  v-model.trim="getRequestData[formOneValue.entityField]" maxlength="64"></el-input>
					</el-form-item>
				
					<el-form-item>
						<el-button type="primary"  size="mini" @click="searchData">查询</el-button>
					</el-form-item>
					
				</el-form>
			</div>
			<div class="components_content_content">
				<el-table  v-if="pageShowData[1]"  size="mini" stripe :data="returnData.list"  border @row-dblclick="selectData"  border  style="width: 100%" highlight-current-row>
					<el-table-column v-if="tableValye.isShow==1" v-for="(tableValye,tableKey) in pageShowData[1].jurconfigtable"  :key="tableKey"  :prop="tableValye.entityField"   :label="tableValye.showField">
						<template  slot-scope="scope">
							<div>
								{{scope.row[tableValye.entityField]}}
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="components_content_bottom">
				<el-pagination
					background
					@size-change="setDataPageSize"
					@current-change="setDataPageNumber"
					:current-page="getRequestData.page"
					:page-sizes="[30,50,100,500]"
					:page-size="30"
					layout="total, sizes, prev, pager, next, jumper"
					:total="returnData.total">
				</el-pagination>
			</div>
		</div>
	</el-dialog>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
	name:'stopSellingTemplate',
	//import引入的组件需要注入到对象中才能使用
	components: {},
	data() {
		//这里存放数据
		return {
			dialogVisible:false,
			getRequestData:{
				bgmId:'',
				bgmName:'',
				page:1,
				rows:30,
				start:'',
				end:'',
			},
			returnData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			pageShowData:[],
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {
		'getRequestData.bgmName':{
			handler:function(newValue,oldValue){
				if(newValue==''){
					this.getRequestData.bgmId = ''
				}
			},
			deep:true,
		}
	},
	//方法集合
	methods: {
		selectDataAction(selectedData={},name,value){
			switch(name){
				case 'bgmId':
					this.getRequestData.bgmId = selectedData.bgmId
					this.getRequestData.bgmName = selectedData.bgmName
				break;
				
				default:
					this.getRequestData[name] = value
			}
		},
		
		openBox(){
			this.getPageInfo()
			this.getDataList()
			this.dialogVisible = true
		},
		selectData(row, column, event){
			this.dialogVisible = false
			this.$parent.selectDataAction(row)
		},
		async getPageInfo(){
			var pathId = parent.getMenuInfo('/stopSellingList')
			let responseData =  await this.$http.pageFormText({ids:[pathId.jurId]})
			if(responseData.status == 200){
				this.pageShowData = responseData.result
				console.log(this.pageShowData)
			
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1
			this.getDataList()
		},
		// 数据翻页
		setDataPageNumber(val){
			this.getRequestData.page = val
			this.getDataList()
		},
		
		// 切换显示条数
		setDataPageSize(val){
			this.getRequestData.page = 1
			this.getRequestData.rows = val
			this.getDataList()
		},
		
		
		// 获取数据列表
		async getDataList(){
			let responseData =  await this.$http.getYesStopSellingList(this.getRequestData)
			if(responseData.status == 200){
				this.returnData.list = responseData.result.list
				this.returnData.pages = responseData.result.pages
				this.returnData.total = responseData.result.total
				this.returnData.pageNum = responseData.result.pageNum
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() {}, //生命周期 - 创建之前
	beforeMount() {}, //生命周期 - 挂载之前
	beforeUpdate() {}, //生命周期 - 更新之前
	updated() {}, //生命周期 - 更新之后
	beforeDestroy() {}, //生命周期 - 销毁之前
	destroyed() {}, //生命周期 - 销毁完成
	activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
